/*
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 *
 */

import {ReactComponent as Gear} from "../assets/img/PartIcons/gear.svg";
import {ReactComponent as LinkArrow} from "../assets/img/icons/link-arrow.svg";
import {ReactComponent as ArrowRight} from "../assets/img/icons/arrow-right-white.svg";
import {ReactComponent as DismabtlerCar} from "../assets/img/home/dismantler_vehicles.svg";
import Map from "../assets/img/home/map.png";
import car from "../assets/img/home/car.png";
import part from "../assets/img/home/part.png";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from "swiper";
import { useTranslation } from 'react-i18next';

import 'swiper/css';
import "swiper/css/navigation";
import {Link, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import useAxiosJTW from "../Hooks/useAxiosJTW";
import SEO from "../components/SEO";

function Home(){

    const [totalParts, setTotalParts] = useState(0);
    const [totalAds, setTotalAds] = useState(0);
    const [totalDismantlers, setTotalDismantlers] = useState(0);
    const [makes, setMakes] = useState('');

    const axiosJWT = useAxiosJTW();
    const { t, i18n } = useTranslation();
    const params = useParams();

    const getHomeData = (signal) => {
        axiosJWT.get('api/gethome', {signal}).then( (response) => {
            if(response.status === 200){
                setTotalParts(response.data.total_parts || 0);
                setTotalAds(response.data.total_ads || 0);
                setTotalDismantlers(response.data.total_dismantlers || 0);
                setMakes(response.data.makes || []);
            }
        } ).catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        const controller = new AbortController();
        const signal= controller.signal;

        getHomeData(signal);

        return () => {controller.abort();}
    }, [params]);

    return(
        <>
            <SEO
                title={ t('meta_title.home' ) }
                description={ t('meta_description.home' ) }
            />
            <section className='home-parts'>
                <div className='container home-parts__container'>
                    <div className='home-parts__header'>
                        <div className='home-parts__row'>
                            <div className='home-parts__col home-parts__col--head'>
                                <div className='home-parts__title'>{ t('home.heroTitle' ) }</div>
                                <div className='home-parts__text'>{t('home.heroSubTitle', {totalDismantlers: totalDismantlers})}</div>
                            </div>
                            <div className='home-parts__col home-parts__col--info'>

                                <div className='post-counter'>
                                    <div className='post-counter__icon'><Gear/></div>
                                    <div className='post-counter__content'>
                                        <div className='post-counter__label'>{t('home.partsin')}</div>
                                        <div className='post-counter__result'>{totalParts}</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className='home-parts__body'>
                        <div className='home-parts__row-bottom'>
                            <div className='home-parts__col-bottom'>
                                <Link to={`/${i18n.language}/models`} className='h-parts-box'>
                                    <div className='h-parts-box__icon h-parts-box__icon--car'>
                                        <img src={car} alt='search by model'/>
                                    </div>
                                    <div className='h-parts-box__content'>
                                        <div className='h-parts-box__title'>{t('home.heroButton1Title')}</div>
                                        <div className='h-parts-box__text'>{t('home.heroButton1SubTitle')}</div>
                                    </div>
                                    <div className='h-parts-box__icon h-parts-box__icon--arrow'><LinkArrow/></div>
                                </Link>
                            </div>
                            <div className='home-parts__col-bottom'>
                                <Link to={`/${i18n.language}/parts/categories`} className='h-parts-box'>
                                    <div className='h-parts-box__icon h-parts-box__icon--car'>
                                        <img src={part} alt='search by category'/>
                                    </div>
                                    <div className='h-parts-box__content'>
                                        <div className='h-parts-box__title'>{t('home.heroButton2Title')}</div>
                                        <div className='h-parts-box__text'>{t('home.heroButton2SubTitle')}</div>
                                    </div>
                                    <div className='h-parts-box__icon h-parts-box__icon--arrow'><LinkArrow/></div>
                                </Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
            {(() => {
                if(makes.length){
                    return(
                        <>
                            <section className='home-brands'>
                                <div className='home-brands__header'>
                                    <div className='container-block'>
                                        <div className='container-block__inner bg-white'>
                                            <div className='home-brands__title'>
                                                {t('home.brandsTitle')}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className='home-brands__body'>
                                    <div className='container-block'>
                                        <div className='container-block__inner'>

                                            <div className='brand-slider'>
                                                <Swiper
                                                    spaceBetween={5}
                                                    slidesPerView={"auto"}
                                                    navigation={true}
                                                    modules={[Navigation]}
                                                >
                                                    { makes.map( (item, index) => {
                                                        if (item.total_ads != null){
                                                            return (
                                                            <SwiperSlide key={index}>
                                                                <Link to={`/${i18n.language}/models/?make=${item.slug}`} className='brand-slide'>
                                                                    <span className='brand-slide__img'><img src={item.logo} alt={item.title} /></span>
                                                                    <span className='brand-slide__title'>{item.title}</span>
                                                                    <span className='brand-slide__num'>( {item.total_ads} )</span>
                                                                </Link>
                                                            </SwiperSlide>
                                                            )
                                                        }
                                                    } ) }

                                                </Swiper>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className='home-brands__footer'>
                                    <Link to={`/${i18n.language}/models`} className='btn btn-primary btn-icon btn-icon-right'>
                                        {t('home.brandsBtn')} <ArrowRight/>
                                    </Link>
                                </div>
                            </section>
                        </>
                    )
                }

            })()}
            {/*<section className='home-values'>*/}
            {/*    <div className='home-values__header'>*/}
            {/*        <div className='container-block'>*/}
            {/*            <div className='container-block__inner'>*/}
            {/*                <div className='home-values__title'>*/}
            {/*                    {t('home.valuesTitle')}*/}
            {/*                </div>*/}
            {/*            </div>*/}

            {/*        </div>*/}
            {/*    </div>*/}
            {/*    <div className='home-values__body'>*/}

            {/*        <div className='container-block'>*/}
            {/*            <div className='container-block__inner'>*/}
            {/*                <div className='home-values__box'>*/}
            {/*                    <div className="row">*/}
            {/*                        <div className="home-values__col home-values__col--1 col-12 col-xl-3">*/}

            {/*                            <div className='home-values__text'>*/}
            {/*                                <QuestionIcon/>*/}
            {/*                                <div className="question-text">100%</div>*/}
            {/*                                <div className="question-text question-text--dark">{t('home.free')}</div>*/}
            {/*                                <div className="question-text">{t('home.req')}</div>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}

            {/*                        <div className="home-values__col home-values__col--2 col-12 col-xl-6">*/}
            {/*                            <div className='home-values__text'>*/}
            {/*                                <p className="plane-text">{t('home.valuesText')}</p>*/}
            {/*                                <p className="plane-text"> Autorec will share your request with all the professional car dismantlers in Austria and you will receive reliable answers about the part you are looking for.</p>*/}
            {/*                                <Link to={`/${i18n.language}/pricing`} className="btn btn-primary btn-icon btn-icon-right disabled">{t('home.GotoRequestForm')}<ArrowRight/></Link>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}

            {/*                        <div className="home-values__col home-values__col--3 col-12 col-xl-3" style={{ backgroundImage: `url(${MailBg})` }}>*/}
            {/*                            <div className="home-values__text miss-out">*/}
            {/*                                <h2 className="miss-out__title">{t('home.DontMissOut')}</h2>*/}
            {/*                                <p className="miss-out__text">{t('home.Receivefree')}</p>*/}
            {/*                                <Link to={`/${i18n.language}/how-it-works`} className="btn btn-primary btn-icon btn-icon-right d-inline-flex">{t('home.LearnMore')}<ArrowRight/></Link>*/}
            {/*                            </div>*/}

            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}

            {/*    </div>*/}
            {/*</section>*/}
            <section className='home-everywhere'>
                <div className='container-block'>
                    <div className='container-block__inner'>
                        <div className='row'>
                            <div className="col-12 col-xl-6 everywhere-box everywhere-box--left">
                                {/*<p className="plane-text">{t('home.alwaysTitle')}</p>*/}
                                <p className="plane-text">{t('home.alwaysText', {totalDismantlers: totalDismantlers})}</p>
                                <Link to={`/${i18n.language}/cars/listing`} className="btn btn-primary btn-icon btn-icon-right d-inline-flex">{t('home.brandsBtn')} <ArrowRight/></Link>
                            </div>
                            <div className="col-12 col-xl-6 everywhere-box everywhere-box--right" style={{ backgroundImage: `url(${Map})` }}>
                                <div className="everywhere-text">
                                    <div className="everywhere-text__title">{t('home.ALWAYS')}</div>
                                    <div className="everywhere-text__subtitle">&amp; {t('home.EVERYWHERE')}</div>
                                    <div className="everywhereBox">
                                        <div className="everywhereBox__text">{t('home.vehicleDismantlers')}</div>
                                        <div className="everywhereBox__num">{totalAds}</div>
                                        <div className="everywhereBox__icon"><DismabtlerCar/></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Home;